var React = require('react');

function TrashCan (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#7088A1","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","d":"M2 4.8h12.133m-.933.747v9.146A1.32 1.32 0 0 1 11.867 16H5.2a1.32 1.32 0 0 1-1.333-1.307V5.547m2-.934V3.307A1.32 1.32 0 0 1 7.2 2h2.667A1.32 1.32 0 0 1 11.2 3.307v1.306"}));
}

TrashCan.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18"};

module.exports = TrashCan;

TrashCan.default = TrashCan;
